/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
import { useState, useEffect } from 'react';
import { z } from 'zod';
import adminServices from '../../../../services/adminServices';
import SnackBar from '../../../../components/snackbar/snackbar';

const ROLE_MAP = {
  'Client Admin': 'CLIENT_ADMIN',
  'Content Creator': 'CONTENT_WRITER',
};

const nameField = z
  .string()
  .min(1, 'Required')
  .regex(/^[a-zA-Z\s'-]+$/, 'Only letters allowed');

const emailField = z
  .string()
  .min(1, 'Required')
  .email('Invalid email');

const inviteSchema = z.object({
  firstName: nameField.refine((v) => v.trim().length > 0, 'First name is required'),
  lastName: nameField.refine((v) => v.trim().length > 0, 'Last name is required'),
  email: emailField,
});

const editSchema = z
  .object({
    firstName: nameField.refine((v) => v.trim().length > 0, 'First name is required'),
    lastName: nameField.refine((v) => v.trim().length > 0, 'Last name is required'),
    newPassword: z.string().optional(),
    confirmPassword: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.newPassword) {
      if (data.newPassword.length < 4) {
        ctx.addIssue({ path: ['newPassword'], code: z.ZodIssueCode.custom, message: 'Min 4 characters' });
      }
      if (/\s/.test(data.newPassword)) {
        ctx.addIssue({ path: ['newPassword'], code: z.ZodIssueCode.custom, message: 'No spaces allowed' });
      }
      if (data.newPassword !== data.confirmPassword) {
        ctx.addIssue({ path: ['confirmPassword'], code: z.ZodIssueCode.custom, message: 'Passwords do not match' });
      }
    }
  });

const replaceSchema = z.object({
  firstName: nameField.refine((v) => v.trim().length > 0, 'First name is required'),
  lastName: nameField.refine((v) => v.trim().length > 0, 'Last name is required'),
  email: emailField,
});

// Helper: flatten Zod errors into { field: message }
const parseZodErrors = (result) => {
  const errs = {};
  if (!result || result.success) return errs;
  const issues = result.error?.issues || result.error?.errors || [];
  issues.forEach((e) => {
    const key = e.path[0];
    if (key && !errs[key]) errs[key] = e.message;
  });
  return errs;
};

export default function UsersAndRoles({ clientDetails, userList, refreshUsers, refreshClient }) {
  const [inviteOpen, setInviteOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarTitle, setSnackbarTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ firstName: '', lastName: '', email: '', role: 'Client Admin' });
  const [errors, setErrors] = useState({});

  // Edit drawer
  const [editOpen, setEditOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [editForm, setEditForm] = useState({ firstName: '', lastName: '', newPassword: '', confirmPassword: '' });
  const [editErrors, setEditErrors] = useState({});
  const [editLoading, setEditLoading] = useState(false);

  // Replace modal
  const [replaceModal, setReplaceModal] = useState({ open: false, currentUserId: null });
  const [replaceForm, setReplaceForm] = useState({ firstName: '', lastName: '', email: '' });
  const [replaceErrors, setReplaceErrors] = useState({});
  const [replaceLoading, setReplaceLoading] = useState(false);

  // Confirm modals
  const [confirmDeactivate, setConfirmDeactivate] = useState({ open: false, userId: null, userName: '' });
  const [confirmReactivate, setConfirmReactivate] = useState({ open: false, userId: null, userName: '' });

  const isFullCreator = clientDetails?.featureToggleMode === 'FULL_CREATOR';

  const snackbarHandle = (message) => {
    setOpenSnackbar(true);
    setSnackbarTitle(message);
  };
    const hasActiveClientAdmin = userList.some(
    (u) => u.role === 'CLIENT_ADMIN' && u.status === 'ACTIVE'
  );

  const emailExistsInList = (email, excludeEmail = null) => {
    const normalised = email.trim().toLowerCase();
    return userList.some((u) => {
      if (excludeEmail && u.email?.toLowerCase() === excludeEmail.toLowerCase()) return false;
      return u.email?.toLowerCase() === normalised;
    });
  };


  // ── Invite ──────────────────────────────────────────────
  const handleInvite = async () => {
    const result = inviteSchema.safeParse(form);
    if (!result.success) { setErrors(parseZodErrors(result)); return; }

    // only one active Client Admin allowed
    if (ROLE_MAP[form.role] === 'CLIENT_ADMIN' && hasActiveClientAdmin) {
      setErrors({ role: 'An active Client Admin already exists. Remove the current one before inviting a new one.' });
      return;
    }

    const normalizedEmail = form.email.trim().toLowerCase();
    const emailExists = userList?.some(
      (u) => u.email?.trim().toLowerCase() === normalizedEmail
    );
    if (emailExists) {
      setErrors({ email: 'A user with this email already exists (case-insensitive).' });
      return;
    }

    setLoading(true);
    try {
    const payload = {
        firstName: form.firstName.trim(),
        lastName: form.lastName.trim(),
        email: normalizedEmail,
        role: ROLE_MAP[form.role],
        schema: `tenant_${clientDetails.slug}`
    };

    const response = clientDetails.featureToggleMode === 'FULL_CREATOR'
        ? await adminServices.postCreateAdminUser(clientDetails?.id, payload)
        : await adminServices.postCreateAdmin(clientDetails?.id, payload);

    if (response.ok) {
        snackbarHandle('User invited successfully');
        setInviteOpen(false);
        setForm({ firstName: '', lastName: '', email: '', role: 'Client Admin' });
        setErrors({});
        refreshUsers();
        refreshClient();
    } else {
        snackbarHandle(response.data?.message || 'Something went wrong');
    }
} catch (e) { console.log(e); }
    setLoading(false);
  };

  const handleCloseInvite = () => {
    setInviteOpen(false);
    setForm({ firstName: '', lastName: '', email: '', role: 'Client Admin' });
    setErrors({});
  };

  // ── Edit ────────────────────────────────────────────────
  const handleEditClick = (user) => {
    setEditUser(user);
    setEditForm({
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      newPassword: '',
      confirmPassword: '',
    });
    setEditErrors({});
    setEditOpen(true);
  };

  const handleCloseEdit = () => {
    setEditOpen(false);
    setEditUser(null);
    setEditForm({ firstName: '', lastName: '', newPassword: '', confirmPassword: '' });
    setEditErrors({});
  };

  const handleSaveEdit = async () => {
    const result = editSchema.safeParse(editForm);
    if (!result.success) { setEditErrors(parseZodErrors(result)); return; }
    setEditLoading(true);
    try {
      const payload = {
        firstName: editForm.firstName.trim(),
        lastName: editForm.lastName.trim(),
        ...(editForm.newPassword ? { password: editForm.newPassword } : {}),
      };
      const response = await adminServices.updateUser(clientDetails?.id, editUser.id, payload);
      if (response.ok) {
        snackbarHandle('User updated successfully');
        handleCloseEdit();
        refreshUsers();
        refreshClient();
      } else {
        snackbarHandle(response.data?.message || 'Failed to update user');
      }
    } catch (e) { console.log(e); }
    setEditLoading(false);
  };

  const handleReplaceClick = (userId, userEmail) => {
    setReplaceModal({ open: true, currentUserId: userId, currentEmail: userEmail });
    setReplaceForm({ firstName: '', lastName: '', email: '' });
    setReplaceErrors({});
  };
  const handleCloseReplace = () => {
    setReplaceModal({ open: false, currentUserId: null });
    setReplaceForm({ firstName: '', lastName: '', email: '' });
    setReplaceErrors({});
  };

  const handleReplaceConfirm = async () => {
    // schema validation
    const result = replaceSchema.safeParse(replaceForm);
    if (!result.success) { setReplaceErrors(parseZodErrors(result)); return; }

    // 2. Case-insensitive duplicate check 
    if (emailExistsInList(replaceForm.email, null)) {
      const typedNormalised = replaceForm.email.trim().toLowerCase();
      const currentNormalised = replaceModal.currentEmail?.toLowerCase();
      if (typedNormalised === currentNormalised) {
        setReplaceErrors({ email: 'The new admin email cannot be the same as the current admin email.' });
        return;
      }
      setReplaceErrors({ email: 'This email is already registered. Email addresses are treated as case-insensitive.' });
      return;
    }
    setReplaceLoading(true);
    try {
      // Step 1 — deactivate current admin
      const deactivateRes = await adminServices.handleUserStatus(
        clientDetails?.id, replaceModal.currentUserId, { status: 'INACTIVE' }
      );
      if (!deactivateRes.ok) {
        snackbarHandle(deactivateRes.data?.message || 'Failed to remove current admin');
        setReplaceLoading(false);
        return;
      }

      const inviteRes = await adminServices.postReplaceAdmin(clientDetails?.id, {
        firstName: replaceForm.firstName.trim(),
        lastName: replaceForm.lastName.trim(),
        email: replaceForm.email.trim().toLowerCase(), // normalise to lowercase before sending
        role: 'CLIENT_ADMIN',
        currentEmail: replaceModal.currentEmail,
      });
      if (inviteRes.ok) {
        snackbarHandle('Client Admin replaced successfully');
        handleCloseReplace();
        refreshUsers();
        refreshClient();
      } else {
        snackbarHandle(inviteRes.data?.message || 'Failed to invite new admin');
      }
    } catch (e) { console.log(e); }
    setReplaceLoading(false);
  };

  // ── Deactivate ──────────────────────────────────────────
  const handleDeactivateConfirm = async () => {
    try {
      const response = await adminServices.handleUserStatus(
        clientDetails?.id, confirmDeactivate.userId, { status: 'INACTIVE' }
      );
      if (response.ok) { snackbarHandle('User deactivated'); refreshUsers();  refreshClient();}
      else snackbarHandle(response.data?.message || 'Failed to deactivate');
    } catch (e) { console.log(e); }
    setConfirmDeactivate({ open: false, userId: null, userName: '' });
  };

  // ── Reactivate ──────────────────────────────────────────
  const handleReactivateConfirm = async () => {
    try {
      const response = await adminServices.handleUserStatus(
        clientDetails?.id, confirmReactivate.userId, { status: 'ACTIVE' }
      );
      if (response.ok) { snackbarHandle('User reactivated'); refreshUsers(); refreshClient(); }
      else snackbarHandle(response.data?.message || 'Failed to reactivate');
    } catch (e) { console.log(e); }
    setConfirmReactivate({ open: false, userId: null, userName: '' });
  };

  // ── Helpers ─────────────────────────────────────────────
  const getRoleDisplay = (role) => {
    if (role === 'CLIENT_ADMIN') return { label: 'Client Admin', color: 'text-blue-600' };
    if (role === 'CONTENT_WRITER') return { label: 'Content Creator', color: 'text-purple-600' };
    if (role === 'MANAGER') return { label: 'Manager', color: 'text-blue-600' };
    return { label: '-', color: 'text-gray-400' };
  };

  const getDisplayName = (user) =>
    user.name || `${user.firstName || ''} ${user.lastName || ''}`.trim() || '-';

  const renderActions = (user) => {
    console.log('USER:', user);
    const isClientAdmin = user.role === 'CLIENT_ADMIN';
    const isManager = user.role === 'MANAGER';
    const isActive = user.status === 'ACTIVE';
    const hasLoggedIn = !!(user.last_login_datetime || user.lastlogin);
    if (isManager) { return null;}

    return (
      <div className="flex items-center gap-3">
        <button
          onClick={() => handleEditClick(user)}
          className="text-blue-600 hover:text-blue-800 text-xs font-medium"
        >
          Edit
        </button>

        {isClientAdmin ? (
          isActive ? (
            <>
          <button
            onClick={() => handleReplaceClick(user.id, user.email)}
            className="text-orange-500 hover:text-orange-700 text-xs font-medium"
          >
            Replace
          </button>
                    <button
                onClick={() => setConfirmDeactivate({ open: true, userId: user.id, userName: getDisplayName(user) })}
                className="text-red-500 hover:text-red-700 text-xs font-medium"
              >
                Deactivate
              </button>
            </>
          ) : (
            hasLoggedIn && (
            <button
                onClick={() => setConfirmReactivate({ open: true, userId: user.id, userName: getDisplayName(user) })}
                className="text-green-600 hover:text-green-800 text-xs font-medium"
              >
                Reactivate
              </button>
            )
          )
        ) : (
          isActive ? (
          <button
            onClick={() => setConfirmDeactivate({ open: true, userId: user.id, userName: getDisplayName(user) })}
            className="text-red-500 hover:text-red-700 text-xs font-medium"
          >
            Deactivate
          </button>
        ) : (
          hasLoggedIn && (
            <button
              onClick={() => setConfirmReactivate({ open: true, userId: user.id, userName: getDisplayName(user) })}
              className="text-green-600 hover:text-green-800 text-xs font-medium"
            >
              Reactivate
            </button>
          )
        )
        )}
      </div>
    );
  };

  const renderTableBody = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan={5} className="text-center py-10">
            <div className="flex justify-center">
              <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-600 rounded-full animate-spin" />
            </div>
          </td>
        </tr>
      );
    }
    if (userList?.length === 0) {
      return (
        <tr>
          <td colSpan={5} className="text-center py-8 text-gray-400">No users found.</td>
        </tr>
      );
    }
    return userList.map((user, idx) => (
      <tr key={idx} className="border-b border-gray-100 last:border-0 hover:bg-gray-50">
        <td className="px-4 py-2.5 text-gray-800 font-medium">{getDisplayName(user)}</td>
        <td className="px-4 py-2.5 text-gray-500">{user.email || '-'}</td>
        <td className="px-4 py-2.5">
          <span className={`font-medium ${getRoleDisplay(user.role).color}`}>
            {getRoleDisplay(user.role).label}
          </span>
        </td>
        <td className="px-4 py-2.5">
          <span className={`px-2 py-0.5 rounded text-[10px] font-semibold ${user.status === 'ACTIVE'
            ? 'text-green-600 border border-green-400'
            : 'text-gray-400 border border-gray-300'
            }`}>
            {user.status === 'ACTIVE' ? 'Active' : 'Inactive'}
          </span>
        </td>
        <td className="px-4 py-2.5">{renderActions(user)}</td>
      </tr>
    ));
  };

  // Reusable confirm modal
  const ConfirmModal = ({ open, title, message, confirmLabel, confirmClass, onConfirm, onClose }) => {
    if (!open) return null;
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="absolute inset-0 bg-black/40" onClick={onClose} />
        <div className="relative bg-white rounded-xl shadow-xl p-6 w-[400px] z-10">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
              <svg className="w-4 h-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
              </svg>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-gray-900 mb-1">{title}</h3>
              <p className="text-xs text-gray-500">{message}</p>
            </div>
          </div>
          <div className="flex justify-end gap-2 mt-6">
            <button onClick={onClose}
              className="px-4 py-1.5 text-xs text-gray-600 border border-gray-300 rounded hover:bg-gray-50">
              Cancel
            </button>
            <button onClick={onConfirm}
              className={`px-4 py-1.5 text-xs font-semibold text-white rounded ${confirmClass}`}>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="relative">

      {/* Run Only banner */}
      {!isFullCreator && (
        <div className="mb-4 flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-xs text-blue-700">
          <svg className="w-4 h-4 flex-shrink-0 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 110 20A10 10 0 0112 2z" />
          </svg>
          <span>
            <strong>Run Only client</strong> — 1 Client Admin permitted. Content Creators are not supported.
          </span>
        </div>
      )}

      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-sm font-semibold text-gray-700">Users & Roles</h2>
        <button
          onClick={() => setInviteOpen(true)}
          className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold px-4 py-2 rounded transition-colors"
        >
          + Invite User
        </button>
      </div>

      {/* Table */}
      <div className="border border-gray-200 rounded overflow-hidden">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-200">
              {['Name', 'Email', 'Role', 'Status', 'Actions'].map((h) => (
                <th key={h} className="text-left px-4 py-2 font-semibold text-gray-500 uppercase tracking-wide text-[10px]">
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>{renderTableBody()}</tbody>
        </table>
      </div>

      {/* ── REPLACE MODAL ───────────────────────────────── */}
      {replaceModal.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/40" onClick={handleCloseReplace} />
          <div className="relative bg-white rounded-xl shadow-xl p-6 w-[440px] z-10">

            {/* Title */}
            <div className="flex items-start gap-3 mb-5">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-yellow-100 flex items-center justify-center">
                <svg className="w-4 h-4 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900">Replace Client Admin</h3>
                <p className="text-xs text-gray-500 mt-1">
                  The current admin will lose access immediately. Enter the new admin's details below.
                  You can re-add a previously deactivated admin by entering their email.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              {/* First Name */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={replaceForm.firstName}
                  onChange={(e) => { setReplaceForm({ ...replaceForm, firstName: e.target.value }); setReplaceErrors({ ...replaceErrors, firstName: '' }); }}
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${replaceErrors.firstName ? 'border-red-400' : 'border-gray-300'}`}
                />
                {replaceErrors.firstName && <p className="text-[10px] text-red-500 mt-1">{replaceErrors.firstName}</p>}
              </div>

              {/* Last Name */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={replaceForm.lastName}
                  onChange={(e) => { setReplaceForm({ ...replaceForm, lastName: e.target.value }); setReplaceErrors({ ...replaceErrors, lastName: '' }); }}
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${replaceErrors.lastName ? 'border-red-400' : 'border-gray-300'}`}
                />
                {replaceErrors.lastName && <p className="text-[10px] text-red-500 mt-1">{replaceErrors.lastName}</p>}
              </div>

              {/* Email */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  value={replaceForm.email}
                  onChange={(e) => { setReplaceForm({ ...replaceForm, email: e.target.value }); setReplaceErrors({ ...replaceErrors, email: '' }); }}
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${replaceErrors.email ? 'border-red-400' : 'border-gray-300'}`}
                />
                {replaceErrors.email && <p className="text-[10px] text-red-500 mt-1">{replaceErrors.email}</p>}
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-2 mt-6">
              <button onClick={handleCloseReplace}
                className="px-4 py-1.5 text-xs text-gray-600 border border-gray-300 rounded hover:bg-gray-50">
                Cancel
              </button>
              <button onClick={handleReplaceConfirm} disabled={replaceLoading}
                className="px-4 py-1.5 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded disabled:opacity-50">
                {replaceLoading ? 'Replacing…' : 'Replace Admin'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── EDIT DRAWER ─────────────────────────────────── */}
      {editOpen && editUser && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div className="flex-1 bg-black/40" onClick={handleCloseEdit} />
          <div className="w-96 bg-white h-[calc(100%-64px)] mt-16 shadow-xl flex flex-col">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <div>
                <h2 className="text-sm font-semibold text-gray-800">Edit User</h2>
                <p className="text-xs text-gray-400 mt-0.5">{editUser.email}</p>
              </div>
              <button onClick={handleCloseEdit} className="text-gray-400 hover:text-gray-600">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* User info card */}
            <div className="px-6 py-4 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-semibold text-gray-600">
                  {(editUser.name || editUser.firstName || '?')[0].toUpperCase()}
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-800">{getDisplayName(editUser)}</p>
                  <div className="flex items-center gap-2 mt-0.5">
                    <span className={`text-[10px] font-medium ${getRoleDisplay(editUser.role).color}`}>
                      {getRoleDisplay(editUser.role).label}
                    </span>
                    <span className={`text-[10px] font-semibold ${editUser.status === 'ACTIVE' ? 'text-green-600' : 'text-gray-400'}`}>
                      {editUser.status === 'ACTIVE' ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-3 space-y-1 text-xs text-gray-500">
                <p><span className="font-medium text-gray-600">Email</span> — {editUser.email}</p>
                <p><span className="font-medium text-gray-600">Role</span> — {getRoleDisplay(editUser.role).label}</p>
                {editUser.createdAt && (
                  <p><span className="font-medium text-gray-600">Added</span> — {new Date(editUser.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</p>
                )}
              </div>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5">
              <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">Profile</p>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={editForm.firstName}
                  onChange={(e) => { setEditForm({ ...editForm, firstName: e.target.value }); setEditErrors({ ...editErrors, firstName: '' }); }}
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${editErrors.firstName ? 'border-red-400' : 'border-gray-300'}`}
                />
                {editErrors.firstName && <p className="text-[10px] text-red-500 mt-1">{editErrors.firstName}</p>}
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={editForm.lastName}
                  onChange={(e) => { setEditForm({ ...editForm, lastName: e.target.value }); setEditErrors({ ...editErrors, lastName: '' }); }}
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${editErrors.lastName ? 'border-red-400' : 'border-gray-300'}`}
                />
                {editErrors.lastName && <p className="text-[10px] text-red-500 mt-1">{editErrors.lastName}</p>}
              </div>

              <p className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest flex items-center gap-1">
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
                Reset Password
              </p>
              <p className="text-[10px] text-gray-400 -mt-4">
                Leave blank to keep current password.
              </p>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">New Password</label>
                <input
                  type="password"
                  value={editForm.newPassword}
                  onChange={(e) => { setEditForm({ ...editForm, newPassword: e.target.value }); setEditErrors({ ...editErrors, newPassword: '' }); }}
                  placeholder="Min. 4 characters"
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${editErrors.newPassword ? 'border-red-400' : 'border-gray-300'}`}
                />
                {editErrors.newPassword && <p className="text-[10px] text-red-500 mt-1">{editErrors.newPassword}</p>}
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Confirm New Password</label>
                <input
                  type="password"
                  value={editForm.confirmPassword}
                  onChange={(e) => { setEditForm({ ...editForm, confirmPassword: e.target.value }); setEditErrors({ ...editErrors, confirmPassword: '' }); }}
                  placeholder="Re-enter new password"
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${editErrors.confirmPassword ? 'border-red-400' : 'border-gray-300'}`}
                />
                {editErrors.confirmPassword && <p className="text-[10px] text-red-500 mt-1">{editErrors.confirmPassword}</p>}
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 px-6 py-4 border-t border-gray-200">
              <button onClick={handleCloseEdit}
                className="px-4 py-1.5 text-xs text-gray-600 border border-gray-300 rounded hover:bg-gray-50">
                Cancel
              </button>
              <button onClick={handleSaveEdit} disabled={editLoading}
                className="px-4 py-1.5 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded disabled:opacity-50">
                {editLoading ? 'Saving…' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── INVITE DRAWER ────────────────────────────────── */}
      {inviteOpen && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div className="flex-1 bg-black/40" onClick={handleCloseInvite} />
          <div className="w-96 bg-white h-[calc(100%-64px)] mt-16 shadow-xl flex flex-col">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-sm font-semibold text-gray-800">Invite User</h2>
              <button onClick={handleCloseInvite} className="text-gray-400 hover:text-gray-600">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  First Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={form.firstName}
                  onChange={(e) => { setForm({ ...form, firstName: e.target.value }); setErrors({ ...errors, firstName: '' }); }}
                  placeholder="Enter first name"
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${errors.firstName ? 'border-red-400' : 'border-gray-300'}`}
                />
                {errors.firstName && <p className="text-[10px] text-red-500 mt-1">{errors.firstName}</p>}
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Last Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={form.lastName}
                  onChange={(e) => { setForm({ ...form, lastName: e.target.value }); setErrors({ ...errors, lastName: '' }); }}
                  placeholder="Enter last name"
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${errors.lastName ? 'border-red-400' : 'border-gray-300'}`}
                />
                {errors.lastName && <p className="text-[10px] text-red-500 mt-1">{errors.lastName}</p>}
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => { setForm({ ...form, email: e.target.value }); setErrors({ ...errors, email: '' }); }}
                  placeholder="Enter email"
                  className={`w-full border rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500 ${errors.email ? 'border-red-400' : 'border-gray-300'}`}
                />
                {errors.email && <p className="text-[10px] text-red-500 mt-1">{errors.email}</p>}
              </div>

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">Role</label>
                <select
                  value={form.role}
                  onChange={(e) => { setForm({ ...form, role: e.target.value }); setErrors({ ...errors, role: '' }); }}
                  className="w-full border border-gray-300 rounded px-3 py-2 text-xs text-gray-800 outline-none focus:ring-1 focus:ring-blue-500"
                >
                  <option value="Client Admin">Client Admin</option>
                  {isFullCreator && <option value="Content Creator">Content Creator</option>}
                </select>
                {errors.role && <p className="text-[10px] text-red-500 mt-1">{errors.role}</p>}
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 px-6 py-4 border-t border-gray-200">
              <button onClick={handleCloseInvite}
                className="px-4 py-1.5 text-xs text-gray-600 border border-gray-300 rounded hover:bg-gray-50">
                Cancel
              </button>
              <button onClick={handleInvite} disabled={loading}
                className="px-4 py-1.5 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded disabled:opacity-50">
                {loading ? 'Inviting...' : 'Invite User'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── CONFIRM MODALS ───────────────────────────────── */}
      <ConfirmModal
        open={confirmDeactivate.open}
        title={`Deactivate ${confirmDeactivate.userName}?`}
        message="This user will lose access immediately. You can reactivate them later."
        confirmLabel="Deactivate"
        confirmClass="bg-red-600 hover:bg-red-700"
        onConfirm={handleDeactivateConfirm}
        onClose={() => setConfirmDeactivate({ open: false, userId: null, userName: '' })}
      />

      <ConfirmModal
        open={confirmReactivate.open}
        title={`Reactivate ${confirmReactivate.userName}?`}
        message="This user will regain access to their role immediately."
        confirmLabel="Reactivate"
        confirmClass="bg-green-600 hover:bg-green-700"
        onConfirm={handleReactivateConfirm}
        onClose={() => setConfirmReactivate({ open: false, userId: null, userName: '' })}
      />

      <SnackBar open={openSnackbar} snackbarTitle={snackbarTitle} close={() => setOpenSnackbar(false)} />
    </div>
  );
}